// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"am","arrowBtnBox":"am","arrow-btn-wrap-box":"an","arrowBtnWrapBox":"an","arrow-btn-text":"ao","arrowBtnText":"ao","arrow-btn-arrow":"ap","arrowBtnArrow":"ap"};